@if (rows().length) {
  <div class="flex flex-col gap-3">
    @for (row of rows(); track row.id) {
      <div
        class="border rounded-xl overflow-hidden p-4 shrink-0 relative"
        [ngClass]="{
          'border-red-200 bg-red-50': isHighlighted(row.id),
          'border-slate-200': !isHighlighted(row.id),
          'bg-gray-200/20': !isHighlighted(row.id) && row.isExpanded
        }"
      >
        <div class="flex items-start gap-2.5 relative" [class.pr-56]="rowActionTemplate()">
          <dsm-aps-addendum-preview
            class="flex-1 min-w-0 flex items-start"
            [dealAddendum]="row"
            [isExpanded]="row.isExpanded"
            [showSeq]="false"
            [showActions]="false"
            [showSignOffStatus]="false"
            [showTotal]="showTotal()"
            [showExpandToggle]="expandable()"
            [actionRailAlign]="rowActionTemplate() ? 'center' : 'top'"
            (toggleExpand)="toggleRow(row)"
          />
          @if (rowActionTemplate()) {
            <ng-container
              [ngTemplateOutlet]="rowActionTemplate()!"
              [ngTemplateOutletContext]="{ $implicit: row }"
            ></ng-container>
          }
        </div>

        @if (expandable() && row.isExpanded) {
          <div class="mt-4 pt-4">
            <dsm-aps-addendum-options
              [dealAddendum]="row"
              [projectName]="projectName()"
              [lotNo]="lotNo()"
              [modelId]="modelId()"
              [elevationId]="elevationId()"
              [modelName]="modelName()"
              [elevationLabel]="elevationLabel()"
              [buyerName]="buyerName()"
              [isReadonly]="true"
            />
          </div>
        }
      </div>
    }
  </div>
} @else if (emptyMessage()) {
  <p class="m-0 text-body-sm text-surface-500">{{ emptyMessage() }}</p>
}
